import { createRouter, createWebHistory } from "vue-router";
import taohaomao from "../views/HomeView.vue";
import thhHome from "../views/thhHome.vue";
import AboutView from "../views/AboutView.vue";
import thwHome from "../views/thwHome.vue";
import mhbHome from "../views/mhbHome.vue";
import taohaohao from "../views/taohaohao.vue";
import thbHome from "../views/thbHome.vue";
import taohaowangHome from "../views/taohaowangHome.vue";
import maihaowangHome from "../views/maihaowangHome.vue";
import newThwHome from "../views/newThwHome.vue";
import iosMhb from "../views/iosMhb.vue";
import taohaobangHome from "../views/taohaobangHome.vue";
import company from "../views/company.vue";
import privacy from "@/views/merchant/privacy.vue";
import service from "@/views/merchant/service.vue";
import taohaohaoMerchant from "@/views/merchant/taohaohaoMerchant.vue";
import haomiaomiao from "@/views/haomiaomiao.vue";

import Aiprivacy from "@/views/maihaoba/Aiprivacy.vue";
import Aiservice from "@/views/maihaoba/Aiservice.vue";

import jiufangdianjing from "@/views/jiufangdianjing/company.vue";

import zijiecompany from "@/views/merchant/company.vue"

const routes = [
  {
    path: "/",
    name: "home",
    component: AboutView,
  },
  {
    path: "/thwHome",
    name: "thwHome",
    component: thwHome,
  },
  {
    path: "/mhbHome",
    name: "mhbHome",
    component: mhbHome,
  },
  {
    path: "/taohaohao",
    name: "taohaohao",
    component: taohaohao,
  },

  {
    path: "/thbHome",
    name: "thbHome",
    component: thbHome,
  },
  {
    path: "/taohaowangHome",
    name: "taohaowangHome",
    component: taohaowangHome,
  },
  {
    path: "/maihaowangHome",
    name: "maihaowangHome",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: maihaowangHome,
  },
  {
    path: "/taohaomao",
    name: "taohaomao",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: taohaomao,
  },
  {
    path: "/index",
    name: "index",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: thhHome,
  },
  {
    path: "/newThwHome",
    name: "newThwHome",
    component: newThwHome,
  },
  {
    path: "/iosMhb",
    name: "iosMhb",
    component: iosMhb,
  },
  {
    path: "/taohaobangHome",
    name: "taohaobangHome",
    component: taohaobangHome,
  },
  {
    path: "/company",
    name: "company",
    component: company,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: privacy,
  },
  {
    path: "/service",
    name: "service",
    component: service,
  },
  {
    path: "/Aiprivacy",
    name: "Aiprivacy",
    component: Aiprivacy,
  },
  {
    path: "/Aiservice",
    name: "Aiservice",
    component: Aiservice,
  },
  {
    path: "/merchant",
    name: "merchant",
    component: taohaohaoMerchant,
  },
  {
    path: "/zijiecompany",
    name: "zijiecompany",
    component: zijiecompany,
  },
  
  {
    path: "/haomiaomiao",
    name: "haomiaomiao",
    component: haomiaomiao,
  },
  {
    path: "/jiufangdianjing",
    name: "jiufangdianjing",
    component: jiufangdianjing,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
